import { render, staticRenderFns } from "./RITable.vue?vue&type=template&id=12aa98da&"
import script from "./RITable.vue?vue&type=script&lang=js&"
export * from "./RITable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports